// @flow
import React from 'react';
import { connect } from 'react-redux';
import {
  RecordTimeToMountProvider,
  TimeToMountType,
  TrackingData,
} from '@zapier/perf-utils';
import { recordTimeToMount } from 'app/common/middlewares/timeToMountTrackingMiddleware';

import type { Node } from 'react';
import type { Dispatch } from 'app/common/types';

type Props = {
  children?: Node,
  onMount: (timeToMount: TimeToMountType, trackingData: TrackingData) => void,
};

// This will record the time from preceding routing to first mount/render
const RecordTimeToMountConnector = (props: Props) => {
  return (
    <RecordTimeToMountProvider recordTimeToMount={props.onMount}>
      {props.children}
    </RecordTimeToMountProvider>
  );
};

const mapDispatchToProps = (dispatch: Dispatch) => ({
  onMount: (timeToMountType: TimeToMountType, trackingData: TrackingData) => {
    dispatch(recordTimeToMount({ timeToMountType, trackingData }));
  },
});

export default connect(null, mapDispatchToProps)(RecordTimeToMountConnector);
